import React from 'react';
import PropTypes from 'prop-types';

const GenericFirstHeaderColumn = props => {
  // const onCacTableViewSort = (key, columnIndex) => {
  //   let sortOrder = cacUtils.SORT_DIRECTION.DESC;
  //   if (
  //     props.sortColumnIndex === columnIndex &&
  //     props.sortKey === key
  //   ) {
  //     switch (props.sortOrder) {
  //       case cacUtils.SORT_DIRECTION.DESC:
  //         sortOrder = cacUtils.SORT_DIRECTION.ASC;
  //         break;
  //       case cacUtils.SORT_DIRECTION.ASC:
  //         sortOrder = cacUtils.SORT_DIRECTION.NONE;
  //         break;
  //       default:
  //         sortOrder = cacUtils.SORT_DIRECTION.DESC;
  //     }
  //   }
  //   props.onSort(sortOrder, key, columnIndex);
  // };


  const {
    // sortOrder, sortKey, sortColumnIndex,
    firstHeaderCol, showMainHeader } = props;
  return (
    <div className="column left-column-width main-table-left-column" data-test="genFirstHeaderColComponent" >
      {showMainHeader && <div className="main-table-left-column-save" />}
      <div className="main-table-left-column-filter" style={{ height: '40px' }}>
        <div className="gen-cell">
          {firstHeaderCol && firstHeaderCol.map((item, columnIndex) => (
            <div key={item.label} className="gen-cell--item" title={item.label}>
              <button
                id={`${item.key}-header${columnIndex}`}
                // onClick={() => onCacTableViewSort(item.key, columnIndex)}
                style={{ textAlign: 'left' }}
              >{item.text}
                {/* {sortKey === item.key && sortOrder === 'desc' && sortColumnIndex === columnIndex && <i data-test="desc">▼</i>}
                {sortKey === item.key && sortOrder === 'asc' && sortColumnIndex === columnIndex && <i data-test="asc">▲</i>} */}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

GenericFirstHeaderColumn.propTypes = {
  // sortColumnIndex: PropTypes.number,
  // sortOrder: PropTypes.string,
  // sortKey: PropTypes.string,
  firstHeaderCol: PropTypes.arrayOf(PropTypes.shape({})),
  showMainHeader: PropTypes.bool,
};

export default GenericFirstHeaderColumn;
